import { clear, del, delGroup } from './delete';
import {
    getPhysicsCoordinate,
    getLogicCoordinate,
    getAllLogicCoordinate,
    allCubeIds,
    getLogicCoordinates,
    has,
    getPaintCoordinate,
    getPaintCoordinates
} from './get';
import { setCoordinate } from './set';

export default {
    clear,
    has,
    del,
    delGroup,
    getPhysicsCoordinate,
    getLogicCoordinate,
    setCoordinate,
    getAllLogicCoordinate,
    allCubeIds,
    getLogicCoordinates,
    getPaintCoordinates,
    getPaintCoordinate
}
